import { render, staticRenderFns } from "./NotificacoesModal.vue?vue&type=template&id=52f8d8d3&"
import script from "./NotificacoesModal.vue?vue&type=script&lang=js&"
export * from "./NotificacoesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports